module.exports = kolibriGlobal.lib.apiResource;